import { useEffect, useRef } from 'preact/hooks';
import { Fragment } from 'preact';
import { createPortal } from 'preact/compat';

export function Tools2() {
  const canvasRef = useRef(null);
  const unitRef = useRef(null);
  const inchScaleRef = useRef(null);
  const inchScaleLabelRef = useRef(null);
  const inputXRef = useRef(null);
  const setGuidesRef = useRef(null);
  const clearRef = useRef(null);
  const lockRef = useRef(null);
  const downloadRef = useRef(null);
  const lockBtn = document.querySelector('#lockBtn');


  useEffect(() => {
    const dpi = window.devicePixelRatio || 1;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const unitSelect = unitRef.current;
    const inchScaleSelect = inchScaleRef.current;
    const inchScaleLabel = inchScaleLabelRef.current;


    let guideX = document.querySelector(".ruler-box").getBoundingClientRect().width / 4;
    let startX = null;
    let isGuideLock = false;

    const dpiBase = +localStorage.getItem("dpiBase") || 96;

    function getUnitToPx(unit) {
      switch (unit) {
        case "cm": return (dpiBase / 2.54) * dpi;
        case "mm": return (dpiBase / 2.54) * dpi;
        case "in": return dpiBase * dpi;
      }
    }

    function setupCanvas() {
      const width = document.querySelector(".ruler-box").getBoundingClientRect().width;
      const height = document.querySelector(".ruler-box").getBoundingClientRect().height - 100;
      canvas.style.width = width + "px";
      canvas.style.height = height + "px";
      canvas.width = width * dpi;
      canvas.height = height * dpi;
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.scale(dpi, dpi);
      ctx.clearRect(0, 0, width, height);
      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, canvas.width * 2, canvas.height * 2);
      ctx.fillStyle = "black";
    }

    function drawRulers(unit, inchScale = 16) {
      const unitPx = getUnitToPx(unit) / dpi;
      const divisions = unit === "in" ? inchScale : 10;
      const step = unitPx / divisions;
      const width = document.querySelector(".ruler-box").getBoundingClientRect().width;
      const height = document.querySelector(".ruler-box").getBoundingClientRect().height - 100;

      if (guideX !== null) {
        ctx.fillStyle = "rgba(0, 0, 255, 0.2)";
        ctx.fillRect(0, 0, guideX, height);
        ctx.fillStyle = "black";
        ctx.strokeStyle = "black";
      }

      const drawHorizontal = (yOffset, flip = false) => {
        for (let i = 0; i < width / unitPx; i++) {
          const baseX = i * unitPx;
          for (let j = 0; j < divisions; j++) {
            let x = baseX + j * step;
            let h = 6;
            let label = "";

            if (unit === "in") {
              if (j % (divisions / 2) === 0) {
                h = 16;
                if (j === divisions / 2) label = "½";
              } else if (j % (divisions / 4) === 0) {
                h = 14;
                if (j === divisions / 4) label = "¼";
                else if (j === (divisions * 3) / 4) label = "¾";
              } else if (j % (divisions / 8) === 0) h = 12;
              else if (j % (divisions / 16) === 0) h = 10;
            } else {
              if (j === 5) h = 12;
            }

            ctx.beginPath();
            ctx.moveTo(x, yOffset);
            ctx.lineTo(x, yOffset + (flip ? -h : h));
            ctx.stroke();

            if (label) {
              ctx.font = "10px sans-serif";
              ctx.textAlign = "center";
              ctx.textBaseline = flip ? "bottom" : "top";
              ctx.fillText(label, x, yOffset + (flip ? -h - 2 : h + 10));
            }
          }

          ctx.beginPath();
          ctx.moveTo(baseX + unitPx, yOffset);
          ctx.lineTo(baseX + unitPx, yOffset + (flip ? -20 : 20));
          ctx.stroke();

          ctx.font = "11px sans-serif";
          ctx.textAlign = "center";
          ctx.textBaseline = flip ? "bottom" : "top";
          const labelText = (unit === "mm" ? (i + 1) * 10 : i + 1);
          ctx.fillText(labelText, baseX + unitPx, yOffset + (flip ? -24 : 24));
        }
      };

      drawHorizontal(0);
      drawHorizontal(height, true);

      if (guideX !== null) {
        const val = (guideX * dpi / getUnitToPx(unit)) * (unit === "mm" ? 10 : 1);
        ctx.fillStyle = "blue";
        ctx.font = "16px sans-serif";
        ctx.textAlign = "left";
        ctx.textBaseline = "middle";

        const width = document.querySelector(".ruler-box").getBoundingClientRect().width;

        const text = `${val.toFixed(2)} ${unit}`;
        const textWidth = ctx.measureText(text).width + 8;
        const maxTextX = Math.min(guideX, width - textWidth);

        ctx.fillText(text, maxTextX + 4, height / 2);

        inputXRef.current.value = val.toFixed(2)
      } else {
        inputXRef.current.value = ""
      }
    }

    function render() {
      const unit = unitSelect.value;
      const inchScale = parseInt(inchScaleSelect.value) || 16;
      inchScaleLabel.style.display = unit === "in" ? "inline" : "none";
      setupCanvas();
      drawRulers(unit, inchScale);
    }

    canvas.addEventListener("mousedown", e => {
      if (isGuideLock) return;

      startX = e.offsetX;
    });

    canvas.addEventListener("mousemove", e => {
      if (startX !== null) {
        guideX += e.offsetX - startX;
        startX = e.offsetX;
        const width = document.querySelector(".ruler-box").getBoundingClientRect().width;

        guideX = Math.max(0, Math.min(guideX, width));
        render();
      }
    });

    canvas.addEventListener("mouseup", () => {
      startX = null;
    });

    canvas.addEventListener("mouseleave", () => {
      startX = null;
    });

    canvas.addEventListener("touchstart", e => {
      if (isGuideLock) return;

      startX = e.touches[0].clientX;
    });

    canvas.addEventListener("touchmove", e => {
      if (startX !== null) {
        guideX += e.touches[0].clientX - startX;
        startX = e.touches[0].clientX;
        const width = document.querySelector(".ruler-box").getBoundingClientRect().width;

        guideX = Math.max(0, Math.min(guideX, width));
        render();
      }
    });

    canvas.addEventListener("touchend", () => {
      startX = null;
    });

    setGuidesRef.current.addEventListener("click", () => {
      const width = document.querySelector(".ruler-box").getBoundingClientRect().width;
      const xVal = parseFloat(inputXRef.current.value);
      const unit = unitSelect.value;
      const pxPerUnit = getUnitToPx(unit);

      guideX = xVal >= 0 && !isNaN(xVal) ? (xVal / (unit === "mm" ? 10 : 1)) * pxPerUnit / dpi : 0;
      guideX = Math.max(0, Math.min(guideX, width));
      render();
    });

    clearRef.current.addEventListener("click", () => {
      const width = document.querySelector(".ruler-box").getBoundingClientRect().width;
      guideX = width / 4

      isGuideLock = false;

      render();
    });

    lockRef.current.addEventListener("click", () => {
      isGuideLock = !isGuideLock;

      if (isGuideLock) {
        //unlock
        lockRef.current.innerText = langText["text_ruler_unlock"];
      } else {
        //lock
        lockRef.current.innerText = langText["text_ruler_lock"];
      }
    });

    downloadRef.current.addEventListener("click", () => {
      const dataURL = canvas.toDataURL("image/png");

      const link = document.createElement('a');
      link.href = dataURL;
      link.download = 'ruler-image.png';
      link.click();
    });

    unitSelect.addEventListener("change", render);
    inchScaleSelect.addEventListener("change", render);
    window.addEventListener("resize", render);

    render();

    return () => {
      window.removeEventListener("resize", render);
      unitSelect.removeEventListener("change", render);
      inchScaleSelect.removeEventListener("change", render);
    }
  }, []);

  return (
    <>
      <canvas ref={canvasRef}></canvas>
      {createPortal(
        <div class="controls" style={{ bottom: '60px', direction: "ltr" }}>
          <label>
            {langText['text_ruler_unit']}:
            <select ref={unitRef}>
              <option value="mm">{langText["text_ruler_cm"]}</option>
              <option value="mm">{langText["text_ruler_mm"]}</option>
              <option value="mm">{langText["text_ruler_in"]}</option>
            </select>
          </label>

          <label ref={inchScaleLabelRef} style={{ display: 'none' }}>
            {langText['text_ruler_in_scale']}:
            <select ref={inchScaleRef}>
              <option value="2">1/2</option>
              <option value="4">1/4</option>
              <option value="8">1/8</option>
              <option value="16" selected>1/16</option>
              <option value="32">1/32</option>
            </select>
          </label>

          <div style={{ marginTop: '10px' }}>
            <label>
              X:
              <input type="number" ref={inputXRef} style={{ width: '60px' }} />
            </label>
            <button ref={setGuidesRef}>{langText['text_ruler_set']}</button>
          </div>

          <div className='action' style={{ marginTop: '10px' }}>
            <button ref={clearRef}>{langText['text_ruler_clear']}</button>
            <button id='lockBtn' ref={lockRef}>{langText['text_ruler_lock']}</button>
            <button ref={downloadRef}>{langText['text_ruler_download_iamge']}</button>
          </div>
        </div>,
        document.getElementById('ruler-controller')
      )}
    </>
  );
}
